module.exports = __webpack_public_path__ + "static/media/coupe2.a9dc0dc6.jpg";